import Swiper from "swiper";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class OurExecitives {
    constructor() {
        this.section = document.querySelector('.our-executives');
        this.slider = this.section.querySelector('.swiper--our-executives');
        this.navigationPrev = document.querySelector('.slider-button-prev--our-executives');
        this.navigationNext = document.querySelector('.slider-button-next--our-executives');
        this.pagination = this.section.querySelector('.swiper-pagination-nav--our-executives');


        this.ready();
    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            pagination: {
                el: this.pagination,
                type: 'fraction',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 80,
                },
                1024: {
                    slidesPerView: 2.9,
                    spaceBetween: 32,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 400
                },
                2000: {
                    slidesPerView: 4.9,
                    spaceBetween: 32,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 600
                },
            },
        });

    }

}